import { render, staticRenderFns } from "./AuthorSearch.vue?vue&type=template&id=444c3cf1&"
import script from "./AuthorSearch.vue?vue&type=script&lang=js&"
export * from "./AuthorSearch.vue?vue&type=script&lang=js&"
import style0 from "./AuthorSearch.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports